import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Alert } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import api from "API/Api"
import { Link, useParams } from "react-router-dom"

const EditVehicleCashAdvance = () => {
  const { id } = useParams()
  const formRef = useRef()
  const [transporters, setTransporters] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [categories, setCategories] = useState([])
  const [record, setRecord] = useState(null)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const [rRes, tRes, cRes] = await Promise.all([
          api.get("vehicle-cash-advance/" + id), api.get("transporters"), api.get("vehicle-deduction-categories")
        ])
        const t = tRes.data.data?.data || tRes.data.data || []; setTransporters(Array.isArray(t) ? t : [])
        setCategories(Array.isArray(cRes.data.data) ? cRes.data.data : [])
        const d = rRes.data.data; const rec = Array.isArray(d) && d.length ? d[0] : d; setRecord(rec)
        // Pre-load vehicles for existing transporter
        if (rec && rec.transporter) {
          try { const vr = await api.get("vehicles-by-transporter/" + rec.transporter); setVehicles(vr.data.data || []) } catch (e) {}
        }
      } catch (e) { console.error(e) }
    }; load()
  }, [id])

  const handleTransporter = async v => {
    setVehicles([])
    if (v) { try { const r = await api.get("vehicles-by-transporter/" + v); setVehicles(r.data.data || []) } catch (e) {} }
  }

  const handleSubmit = async (e, values) => {
    try { const r = await api.put("update-vehicle-cash-advance/" + id, values); if (r.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) } } catch (e) { console.error(e) }
  }

  if (!record) return <div className="dashBody"><p>Loading...</p></div>
  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader"><Row><Col md={6}><h4>Edit Vehicle Cash Advance</h4></Col><Col md={6} style={{ textAlign: "right" }}><Link to="/vehicle-cash-advances" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row></div>
      {submitted && <Alert color="success" className="mt-2">Vehicle Cash Advance Updated Successfully!</Alert>}
      <AvForm className="mt-3" onValidSubmit={handleSubmit} ref={formRef} model={record}>
        <Row>
          <Col md={6}>
            <AvField type="select" name="transporter" label="Transporter *" required value={String(record.transporter)} onChange={e => handleTransporter(e.target.value)}>
              <option value="">Select</option>
              {transporters.map((t, i) => <option key={i} value={t.id}>{t.transporterName}</option>)}
            </AvField>
          </Col>
          <Col md={6}>
            <AvField type="select" name="vehicle" label="Vehicle *" required value={String(record.vehicle)}>
              <option value="">Select</option>
              {vehicles.map((v, i) => <option key={i} value={v.id}>{v.vehicleNumber}</option>)}
            </AvField>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="select" name="category" label="Category" value={record.category ? String(record.category) : ""}>
              <option value="">Select</option>
              {categories.map((c, i) => <option key={i} value={c.id}>{c.categoryName}</option>)}
            </AvField>
          </Col>
          <Col md={6}>
            <AvField type="date" name="advanceDate" label="Advance Date *" required value={record.advanceDate} />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="number" name="advanceAmount" label="Advance Amount *" required value={record.advanceAmount} validate={{ required: { value: true }, min: { value: 1 } }} />
          </Col>
          <Col md={6}>
            <AvField type="number" name="deductionPerBill" label="Deduction Amount Per Bill *" required value={record.deductionPerBill} validate={{ required: { value: true }, min: { value: 0 } }} />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <AvField type="textarea" name="remarks" label="Remarks" value={record.remarks || ""} />
          </Col>
          <Col md={6}>
            <div className="mt-4">
              <p><strong>Total Deducted:</strong> ₹{parseFloat(record.totalDeducted || 0).toLocaleString("en-IN")}</p>
              <p><strong>Pending Balance:</strong> ₹{parseFloat(record.pendingBalance || 0).toLocaleString("en-IN")}</p>
              <p><strong>Status:</strong> <span style={{ fontWeight: 600, color: record.status === "active" ? "#16a34a" : record.status === "completed" ? "#0284c7" : "#dc2626" }}>{record.status?.charAt(0).toUpperCase() + record.status?.slice(1)}</span></p>
            </div>
          </Col>
        </Row>
        <button className="btn btn-primary mt-3" type="submit">Save Changes</button>
      </AvForm>
    </div>
  )
}
export default EditVehicleCashAdvance
